import { QueryPropsV2 } from 'constants/service'

import { getQueryStringV2 } from 'utils/api'

import ServiceBase from 'services/ServiceBase'

class FormBuilderSettingsApiClient extends ServiceBase {
  available = (id: string, token: string, deviceTokenNotRequired: boolean) => this.request({
    deviceTokenNotRequired,
    path: `/v2/nurseries/${id}/form-builder-settings/available`,
    token,
  })

  update = (id: string, params: QueryPropsV2 = {}, body: any) => this.request({
    body,
    method: 'PUT',
    path: `/v2/nurseries/${id}/form-builder-settings?${getQueryStringV2(params)}`,
  })
}

export default FormBuilderSettingsApiClient
